import Vue from "vue"
import VueI18n from "vue-i18n"
import content from "./content"
import en from "./i18n/en"

function join(translations) {
  return { ...content, ...translations }
}

const messages = {
  en: join(en),
}

const defaultLocale  = "en"
const selectedLocale = navigator.language

Vue.use(VueI18n)

export default new VueI18n({
  silentTranslationWarn: true,
  locale: Object.keys(messages).find(key => key === selectedLocale) || defaultLocale,
  fallbackLocale: Object.keys(messages).find(key => key === selectedLocale) || defaultLocale,
  messages,
})



// WEBPACK FOOTER //
// ./src/content/index.js